// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__27ODX","additionalInfo":"AgreementModal_additionalInfo__2kIq8"};